<template>
  <div class="d-flex flex-column align-items-center pt-5">
    <div v-if="mode === null" class="d-flex flex-column align-items-center">
      <span class="font-weight-bold">Login with</span>
      <button class="btn btn-outline-primary mt-3" @click="mode = 'idCard'">ID Card</button>
      <button class="btn btn-outline-primary mt-2" @click="mode = 'username'">Username</button>
      <button class="btn btn-outline-primary mt-2" @click="loginWithGoogle">Google</button>
    </div>
    <div v-if="mode === 'idCard'" class="text-center">
      <p class="mt-5 mb-4 h4">Scan ID Card</p>
      <button type="button" class="btn btn-outline-danger" @click="mode = null">Cancel</button>
      <form v-if="idCard.id && idCard.pw" @submit.prevent="loginWithIdCard">
        <TextField v-model="idCard.pin" type="password" placeholder="PIN" autofocus="on" />
      </form>
      <Scanner :expectations="['string']" @scan="handleScan" :redirect="{ string: false }" :uppercase="false" />
    </div>
    <form class="mb-5" @submit.prevent="loginWithEmail" style="min-width: 20rem;" v-if="mode === 'username'">
      <label class="font-weight-bold text-center d-block mb-4">Login with Username & Password</label>
      <div class="form-group">
        <label for="email">Username</label>
        <input type="text" class="form-control" id="email" v-model="email" required />
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" class="form-control" id="password" v-model="password" required />
      </div>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-outline-danger" @click="mode = null">Cancel</button>
        <button type="submit" class="btn btn-primary" :disabled="loading">Login</button>
      </div>
    </form>
  </div>
</template>

<script>
import { auth, fb } from '@/shared/firebase'
import TextField from '@/shared/TextField'
import Scanner from '@/components/Scanner'

export default {
  components: { TextField, Scanner },
  data() {
    return {
      mode: null,
      loading: false,
      email: '',
      password: '',
      idCard: {
        id: null,
        pw: null,
        pin: null
      }
    }
  },
  created() {
    auth
      .getRedirectResult()
      .then(result => {
        if (result.credential) {
          this.$router.replace('/')
        }
      })
      .catch(function(error) {
        console.warn(error)
      })
  },
  methods: {
    loginWithIdCard() {
      this.loading = true
      const { id, pw, pin } = this.idCard
      const email = `${id}@warehouse.mitemma.de`
      auth
        .signInWithEmailAndPassword(email, pw + pin)
        .then(() => {
          this.loading = false
          this.$router.replace('/')
        })
        .catch(err => {
          this.loading = false
          alert(err.message)
        })
    },
    loginWithEmail() {
      this.loading = true
      const email = this.email.includes('@') ? this.email : `${this.email}@login.mitemma.de`
      auth
        .signInWithEmailAndPassword(email, this.password)
        .then(() => {
          this.loading = false
          this.$router.replace('/')
        })
        .catch(err => {
          this.loading = false
          alert(err.message)
        })
    },
    loginWithGoogle() {
      var provider = new fb.auth.GoogleAuthProvider()
      provider.setCustomParameters({
        prompt: 'select_account'
      })
      fb.auth()
        .signInWithRedirect(provider)
        .then(() => {
          this.$router.replace('/')
        })
        .catch(err => {
          alert(err.message)
        })
    },
    handleScan(scan) {
      if (scan.q.length === 68) {
        const id = scan.q.substr(0, 4)
        const pw = scan.q.substr(4, 64)
        this.idCard = { id, pw }
      } else {
        this.$notify({
          group: 'main',
          type: 'scan-warning',
          title: 'Invalid ID Card',
          text: `The scanned code has the wrong format and therefore can't be a valid ID Card.`
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;

  &__inner {
    max-width: 30rem;
    flex-grow: 1;
    padding: 2rem;
    margin: 1rem;
    border: 1px #ddd solid;
  }
}
</style>
